import { ReduxProductCategoryFilter } from "~/Search/components/Filters/components/CategoryFilter/CategoryFilter";
import { SalesFilter } from "~/Search/components/Filters/components/SalesFilter/SalesFilter";
import { RelevantFilter } from "~/Search/components/Filters/components/RelevantFilter/RelevantFilter";
import { Box } from "@mui/material";
import { TechFilterCategory } from "~/Search/components/Filters/components/TechFilter/TechFilterCategory";
import { verticalStacker } from "~/styles/styledMixins";
import {
  type FacetFilterData,
  Filter,
  type FilterConfig,
  type FilterType,
  type TaxonomyFilterData,
  type TechValueFilterCategoryData,
} from "~/Search/filterConfigModels";
import { FacetFilter } from "~/Search/components/Filters/components/FacetFilter/FacetFilter";

interface Props {
  filterConfig: FilterConfig;
  hideTechFilterButtons?: boolean;
  hideNonCategoryFilters?: boolean;
}

export const SearchFilters = ({ filterConfig, hideTechFilterButtons, hideNonCategoryFilters }: Props) => {
  return (
    <Box sx={{ ...verticalStacker() }}>
      {filterConfig.map((item) => {
        return filterRenderMap[item.type]?.(item, { hideNonCategoryFilters, hideTechFilterButtons }) ?? null;
      })}
    </Box>
  );
};

type Config = {
  hideTechFilterButtons?: boolean;
  hideNonCategoryFilters?: boolean;
};

const renderFilter = <T extends FilterConfig[number]>(
  filterType: FilterType,
  item: FilterConfig[number],
  config: Config,
  render: (item: T, config: Config) => React.ReactNode,
): React.ReactNode | null => (item.type === filterType ? render(item as T, config) : null);

const filterRenderMap: Record<FilterType, (item: FilterConfig[number], config: Config) => React.ReactNode | null> = {
  [Filter.RELEVANT]: (_, config) => (
    <Box key={"relevant"} sx={{ py: "16px" }} hidden={config.hideNonCategoryFilters}>
      <RelevantFilter />
    </Box>
  ),
  [Filter.TECH_VALUE]: (item, config) =>
    renderFilter(Filter.TECH_VALUE, item, config, (data: TechValueFilterCategoryData, config) => (
      <TechFilterCategory
        key={data.facetId}
        data={data}
        hidden={config.hideNonCategoryFilters}
        hideTechFilterButtons={config.hideTechFilterButtons}
      />
    )),
  [Filter.FACET]: (item, config) =>
    renderFilter(Filter.FACET, item, config, (data: FacetFilterData, config) => (
      <FacetFilter key={data.code} data={data} hidden={config.hideNonCategoryFilters ?? false} />
    )),
  [Filter.TAXONOMY]: (item, config) =>
    renderFilter(Filter.TAXONOMY, item, config, (data: TaxonomyFilterData) => (
      <ReduxProductCategoryFilter
        key={"productGroup"}
        taxonomy={data.categories}
        initiallyExpanded={data.initiallyExpanded}
      />
    )),
  [Filter.SALES]: (_, config) => (
    <Box key={"salesFilter"} sx={{ py: "16px" }} hidden={config.hideNonCategoryFilters ?? false}>
      <SalesFilter />
    </Box>
  ),
};
